import React, { useEffect, useState } from "react";
import axios from "axios"; // Import Axios
import { showCustomAlert, showCustomAlerterror } from "../customalert";
import { API_BASE_URL } from "../ApiConfig";
import style from '../../css/payment/Paymentcard.module.css';

const PaymentCard = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const [couponCode, setCouponCode] = useState('');
  const [discount, setDiscount] = useState(0);
  const handleApplyCoupon = () => {
    if (couponCode.trim().toLowerCase() === "swingalgo2000") {
      setDiscount(2000);
      showCustomAlert("Coupon applied successfully! ₹2000 off.");
    } else {
      setDiscount(0);
      showCustomAlerterror("Invalid coupon code.");
    }
  };

  const baseAmount = 5000;
  const discountedAmount = baseAmount - discount;
  const gst = 0.18 * discountedAmount;
  const finalAmount = discountedAmount + gst;

  useEffect(() => {
    try {
      const storedEmail = localStorage.getItem("userEmail");
      if (storedEmail) {
        if (storedEmail.startsWith("{") || storedEmail.startsWith("[")) {
          setEmail(JSON.parse(storedEmail));
        } else {
          setEmail(storedEmail);
        }
      }
    } catch (error) {
      console.error("Error parsing email from localStorage:", error);
    }
  }, []);

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };



  const handlePayment = async () => {

    if (!email) {
      showCustomAlerterror("User email not found. Please log in.");
      return;
    }
    setLoading(true);
    const amount = Math.max(finalAmount, 0);
    const isScriptLoaded = await loadRazorpayScript();

    if (!isScriptLoaded) {
      showCustomAlerterror("Failed to load Razorpay.");
      setLoading(false);
      return;
    }

    try {
      // STEP 1: Create Razorpay order
      const { data: paymentData } = await axios.post(
        `${API_BASE_URL}payment/complete_process_payment.php`,
        { amount },
        { withCredentials: true }
      );

      if (paymentData.status === "created") {
        const options = {
          // test
          // key: "rzp_test_MLxrHNXWtIdmfH",

          //live
          key: "rzp_live_VaCqiwAj83b37w",


          amount: paymentData.amount,
          currency: "INR",
          order_id: paymentData.order_id,
          description: `Premium Plan Payment by ${email}`,
          handler: async function (response) {
            // STEP 2: Verify Razorpay Signature
            const { data: result } = await axios.post(
              `${API_BASE_URL}payment/complete_process_payment.php`,
              {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
              },
              { withCredentials: true }
            );

            if (result.status === "success") {
              // showCustomAlert("Payment verified successfully!");
              showCustomAlert(result.message);
              setCouponCode('');
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } else {
              showCustomAlerterror("Payment verification failed");
              setLoading(false);
              setCouponCode('');
            }
          },
          modal: {
            ondismiss: async function () {
              showCustomAlerterror("Payment was not completed. User registration cancelled.");
              setLoading(false);
            },
          },
          prefill: { email },
          theme: { color: "#21486f" },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      } else {
        showCustomAlerterror("Failed to create payment order.");
        setLoading(false);
      }
    } catch (error) {
      showCustomAlerterror("Error processing payment.");
      setLoading(false);
    }
  };
  return (
    <div className="d-flex justify-content-center py-4">

      {loading && (
        <div className={style.loaderOverlay}>
          <div className={style.loader}></div>
        </div>
      )}
      <div className={style.cardContainer}>
        <div className={style.popularTag}>
          Most Popular <span className={style.starIcon}><i className="fa-solid fa-star"></i></span>
        </div>
        <h2 className={style.title}>SWING TRADING</h2>
        <p className={style.subtitle}>A JOURNEY WORTH TAKING!!!</p>
        <hr className={style.divider} />
        <h3 className={style.sectionTitle}>OUR SERVICES</h3>
        <div className={style.service_heading}><i className={`fa-solid fa-hashtag ${style.checkicons_hash}`}></i> PREMIUM SWING SETUPS</div>
        <div className={style.PaymentCard_servicesrow}>
          <ul className={style.serviceList}>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> VCP setup</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> ROCKET BASE setup</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> IPO base setup</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> FNO setup</li>
          </ul>
          <div className={style.service_heading}><i className={`fa-solid fa-hashtag ${style.checkicons_hash}`}> </i> AI FUNDAMENTAL ANALYSIS</div>
          <ul className={style.serviceList}>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> COMPANY ANALYSIS</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> CORP FILLING</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> ANNUAL REPORTS</li>
          </ul>
          <div className={style.service_heading}><i className={`fa-solid fa-hashtag ${style.checkicons_hash}`}> </i> ALGOED SCANNER</div>
          <ul className={style.serviceList}>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> READY TO TRADE STOCKS</li>
            <li><i className={`fa-solid fa-check ${style.checkicons}`}> </i> CHANCE TO JOIN Xploder GROUP - Mission 4000 community</li>
          </ul>
        </div>
        <div className={style.priceSection}>
          <p className={style.priceTitle}>Price</p>
          <p className={style.price} >
            5000 <i className="fa-solid fa-indian-rupee-sign"></i>   <span style={{ fontSize: '.8rem' }}>+ 18% GST  <span className={style.priceDuration} style={{ fontSize: '1rem' }}>for 3 months</span></span>   <br />
          </p>
        </div>

        <div style={{ fontSize: '1rem' }}>
          <div className={style.pricing}>
            {discount > 0 && (
              <div><span className={style.label}>Coupon Discount</span> <span>-₹{discount}</span></div>
            )}
            <div><span className={style.label}>GST @ 18%</span> <span>{gst}</span></div>
            <div className={style.total}><span>Amount Payable</span> <span>₹{finalAmount}</span></div>
          </div>
        </div>
        <div className={style.coupon}>
          <label className={style.signupcontent}>
            Coupon Code
            <div className={style.signupicons}>
              <i className={`fa-solid fa-tag ${style.signupIcons}`}></i>
              <input
                className={style.signupmodalinputtxt}
                type="text"
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                placeholder="Enter coupon code"
              />
              <button type="button" className={style.applybtn} onClick={handleApplyCoupon}>
                Apply
              </button>
            </div>
          </label>
        </div>

        <div className={style.salestags}>
          <div className={style.saleTag}>SUPER</div>
          <div className={style.saleTag2}>SALE</div>
          <button className={style.buyButton} onClick={handlePayment} disabled={loading}>
            {loading ? "Processing..." : "BUY NOW"}
          </button>

        </div>
      </div>
    </div>
  );
};

export default PaymentCard;
